import React from 'react';

import classNames from 'classnames';

import { LegendItem, LegendType } from './ChartLegend.types';

import Label from '../../../common/Labels/Label';

interface Props {
  entries: LegendItem[]
  id?: string,
  showStacked?: boolean,
}

type ShapeComponentType = {
  color: any,
  size?: number,
}

const Square = ({ color, size = 16 }: ShapeComponentType) => (
  <div style={{
    width: size,
    height: size,
    backgroundColor: color,
  }} />
)

const Circle = ({ color, size = 16 }: ShapeComponentType) => (
  <div className="rounded-full" style={{
    width: size,
    height: size,
    backgroundColor: color,
  }} />
)

const Line = ({ color, size = 16 }: ShapeComponentType) => (
  <hr style={{ width: size, border: `1px solid ${color}` }} />
)

type ItemIconType = {
  shape: LegendType,
  color: number,
}

const ItemIcon = ({ shape, color }: ItemIconType) => {
  if (shape === 'line') {
    return <Line color={color} />
  }
  if (shape === 'circle') {
    return <Circle color={color} />
  }

  return <Square color={color} />
}

type ItemEntryType = {
  legendId: string,
  entry: LegendItem,
}

const ItemEntry = ({ legendId, entry }: ItemEntryType) => (
  <div className="flex items-center justify-start mx-1" id={`${legendId}-${entry.id}`}>
    <ItemIcon color={entry.color} shape={entry.shape} />
    <Label className="ml-1">{entry.label}</Label>
  </div>
)

export const ChartLegend = ({ 
  entries,
  id = 'legend',
  showStacked = false,
}: Props) => (
  <div id={id} className={
    classNames('flex items-center justify-center', {
      'flex-col': showStacked
    })
  }>
    {
      entries?.length > 0 && (
        entries.map(entry => (
          <ItemEntry key={`${id}-${entry.id}`} legendId={id} entry={entry} />
        ))
      )
    }
  </div>
)

export default ChartLegend;
